import { useAjax, useMzMutation } from "@bsm/component";
import { AjaxResponseType } from "@bsm/lib";

export const useStudentDeleteMutation = () => {
    const ajax = useAjax()

    return useMzMutation<AjaxResponseType<Record<string, any>>>(
        (payload: TPayload) =>
            ajax.send({
                url: "scholarity/student/remove",
                type: "POST",
                content_type: "application/json",
                data: payload as any,
            }
        ),
        {
            error_message: false,
            success_message: "Student removed successfully"
        }
    );
}

type TPayload = {
    id?: number,
    scholarityId?: number
}